import { useCallback } from "react"
import { flags, useFeatureFlags } from "../lib/feature-flags"

export const EDUCATION_PGM_LEVEL_PURCHASE_PATH = "/payment"

const LEGACY_EDUCATION_PURCHASE_URL_PATTERN =
  /\/(level2reg|level3reg)\.cfm\?entity_id=/i

export const isLegacyEducationPgmPurchaseUrl = url =>
  typeof url === "string" && LEGACY_EDUCATION_PURCHASE_URL_PATTERN.test(url)

export const resolveEducationPgmPurchaseUrl = (
  url,
  isAccountPurchaseEnabled,
) => {
  if (!url) {
    return url
  }

  if (isAccountPurchaseEnabled && isLegacyEducationPgmPurchaseUrl(url)) {
    return EDUCATION_PGM_LEVEL_PURCHASE_PATH
  }

  return url
}

export const getEducationPurchaseLinkProps = href => {
  const isInternal = typeof href === "string" && href.startsWith("/")

  return {
    href,
    ...(isInternal ? {} : { target: "_blank", rel: "noopener noreferrer" }),
  }
}

export const useResolveEducationPgmPurchaseUrl = () => {
  const [isAccountPurchaseEnabled = false] =
    useFeatureFlags([flags.FLAG_FEAT_EDUCATION_PGM_LEVEL_PURCHASE]) ?? []

  return useCallback(
    url => resolveEducationPgmPurchaseUrl(url, isAccountPurchaseEnabled),
    [isAccountPurchaseEnabled],
  )
}
